import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import roundStamp from './Round_stamp.png';
import styles from './BannerSlider.module.css';
import { BannerSliderItem } from './BannerSliderItem';
import { BannerSliderItemMobile } from './BannerSliderItemMobile';

const BannerSlider = () => {
  const isMobile = useMediaQuery(({ breakpoints }) => breakpoints.down('sm'));

  return (
    <section className={styles.banner} aria-label="Banner">
      <div className={styles.contentWrap}>
        {isMobile ? <BannerSliderItemMobile /> : <BannerSliderItem />}
      </div>
      <img src={roundStamp} alt="" className={styles.stamp} aria-hidden />
    </section>
  );
};

export default BannerSlider;
